

<template>
  <div class="study-main">
    <!-- 目录详情开始 -->
    <div class="dir-detail" v-for="(item, key) in children" :key="key">
      <!-- 一级目录的获取 -->
      <p 
        class="detail-title list-p"
        v-show="item.onehidden"
        @click.self="
          showTitle($event, item.parentNodeid, item.courseNodeId, true)
        "
      >
       <span :class="item.children.length == 0?'hidden':'display'">
          <a-icon
            @click="
              showIcon(
                $event,
                item.parentNodeid,
                item.courseNodeId,
                true,
                false,
              )
            "
            v-if="item.show"
            type="caret-down"
          />
          <a-icon
            @click="
              showIcon(
                $event,
                item.parentNodeid,
                item.courseNodeId,
                true,
                false,
              )
            "
            v-else
            type="caret-right"
          />
        </span>
        <span
          @click="
            showIcon(
              $event,
              item.parentNodeid,
              item.courseNodeId,
              true,
              true,
            )
          "
          v-show="item.showText"
          class="edit-chapter-name first-chapter-name"
          :title="item.name"
        >
          {{ item.name }}
        </span>

        <input
          class="edit_input"
          ref="inputVal"
          @keyup.enter="editSave(item.courseNodeId)"
          v-model="item.name"
          v-show="!item.showText"
          type="text"
        />

        <span
          v-show="!item.showText"
          class="edit-cancel"
          @click="editCancel(item.courseNodeId)"
          >{{$t('translateText.catalog.qx')}}</span
        >
        <span
          v-show="!item.showText"
          class="edit-save"
          @click="editSave(item.courseNodeId)"
          >{{$t('translateText.catalog.bc')}}</span
        >
        <a-tooltip placement="top" :title="$t('translateText.catalog.sc')">
          <a-icon
          @click="myDelChapter(item.courseNodeId)"
          v-show="item.miniIcon"
          class="edit-btns edit-del"
          type="delete"
          />
        </a-tooltip>
        
        <ShowLock
          ref="showlock"
          @update="updatestatue"
          :courseNodeId="item.courseNodeId"
          :parentNodeid="item.parentNodeid"
          :nodeState="item.nodeState"
          v-show="item.miniIcon"
          class="edit-btns edit-lock"
        />
        <a-tooltip placement="top" :title="$t('translateText.catalog.bj')">
          <a-icon
          v-show="item.miniIcon"
          @click="editIconTitle(item.courseNodeId)"
          class="edit-btns edit-icon"
          type="edit"
          />
        </a-tooltip>
        
      </p>


      <!-- <div v-for="(item, key) in item.children" :key="key"> -->
      <Catalog @updatestate ="updatestate" @getnode="getnode" @getcoursedata="getcoursedata" ref="catalog" style="padding-left:20px" v-if="item.show" :children="item.children"  />
      <!-- </div> -->
    </div>
    <!-- 目录详情结束 -->
    <p
      id="add-chapter-input"
      class="detail-title add-chapter-input add-chapter-input-peer"
      v-show="addPeerShow"
    >
      <a-icon v-if="false" type="caret-down" />

      <!-- <span v-show='addPeerShow' class="add-dir-peer"></span> -->
      <input
        ref="peerInput"
        class="edit_input"
         @keyup.enter="addSave()"
        v-show="addPeerShow"
        v-model="addPeerText"
        type="text"
      />

      <span
        v-show="addPeerShow"
        id="add-dir-cancel"
        class="edit-cancel"
        @click="addCancel($event)"
        >{{$t('translateText.catalog.qx')}}</span
      >
      <span
        v-show="addPeerShow"
        id="add-dir-save"
        class="edit-save"
        @click="addSave()"
        >{{$t('translateText.catalog.bc')}}</span
      >
    </p>
    <!-- 添加同级目录文本框结束 -->

    <!-- 添加 子级目录文本框开始 -->
    <p
      class="detail-title add-chapter-input add-chapter-input-son"
      v-show="addSonShow"
      @click.self="showTitleOne($event)"
    >
      <a-icon v-if="false" type="caret-down" />

      <input
        ref="sonInput"
        class="edit_input"
        @keyup.enter="addSonSave()"
        
        v-show="addSonShow"
        v-model="addSonText"
        type="text"
      />

      <span
        v-show="addPeerSpan"
        id="add-son-cancel"
        class="edit-cancel"
        @click="addSonCancel($event)"
        >{{$t('translateText.catalog.qx')}}</span
      >
      <span
        v-show="addPeerSpan"
        id="add-son-save"
        class="edit-save"
        @click="addSonSave()"
        >{{$t('translateText.catalog.bc')}}</span
      >
    </p>
    <!-- 添加 子级目录文本框结束 -->
      <s-modal
          :visible="svisible"
          @cancel="cancelFn()"
          @confirm="confirmFn(chapter_key)"
      >
      {{$t('translateText.catalog.qrsc')}}
      </s-modal>
  </div>
</template>

<script>
import sModal from "@/components/Modal/secondModal"; //对话框modal
import ShowLock from "@/views/Resource/CourseLive/ShowLock.vue";
import {
  addCourseNode,
  deleteCourseNode,
  updateCourseNode,
} from "../utils/api";
import CryptoJS from "crypto-js";
export default {
  name: "Catalog",
  props: { 
    children: Array,
    initialarr:Array,
    compile:Boolean,
    // keepright:String,
  },
  
  data() {
    return {
      originaldata:[],//原始数据
      padding:"5px",//控制子级目录向右一点
      courseinfoarr: [], //用于全选时 子选择框的勾选
      checkModel: [], //双向数据绑定的数组
      indexarr: [], //选中子选择框的索引数组
      pitcharr: [], //用于判断子选择框选择数是否和总数据相等
      checked: false, //控制全选复选框
      // checkednode:"",//选中的目录，
      NodeName: "",
      nodeState: "",
      nodelist:[],//选中的目录id以及目录下的子目录id
      addson: true, //控制添加子级目录按钮的显示与隐藏
      courseNodeId: -1, //选中的目录id
      parentNodeid: "", //添加目录所用到的已选中目录父级id
      listNames: [], //转变成树形结构之后的数据
      chapterName: "细胞病理学第一章",
      section_name: [],
      searchcontent: "", //搜索框内输入的内容
      edit_del_turn: false,

      // search文本框中搜索的值
      searchText: "",
      // 设置精确查找后渲染页面的显示或隐藏
      exactItem: false,

      // 设置精确查找后的数组
      searchItem: [],

      //三级目录
      show_son_one: true,
      show_son_two: true,
      show_son_three: true,

      edit_chapter_turn: false, //设置编辑章节的页面弹窗

      // imgObj: [
      //   { imgUrl: require("@/assets/imgs/zyp1.png") },
      //   // { imgUrl: require('@/assets/img/')}
      // ],
      file_attr: [],
      show: [],
      item_show: false,
      checkTurn: false,
      checkAllTurn: true,
      keys_arr: [], //要删除的所有key值
      svisible: false,
      edit_btn_show: false,
      lock_show: true,
      del_show: true,
      old_text: "细胞病理学第一章",
      chapterConfirm: false,
      // 章节的删除开关
      chapter_del_turn: false,
      chapter_key: 0,
      // 定义一个计数器，计算删除元素的个数
      count: true,
      // 添加目录的索引
      add_dir_index: [],
      // 设置添加同级目录的显示或隐藏
      addPeerShow: false,
      // 设置添加子级目录的显示或隐藏
      addSonShow: false,
      add_dir_name: "",
      add_inputText: "",
      // 所有一级目录的个数
      all_dir_first: 1,
      // 所有二级目录的个数
      all_dir_second: 2,
      // 控制背景颜色的显示或隐藏
      bg_turn: false,
      test_check_turn: false,
      // 控制添加同级目录的保存和取消按钮的显示或隐藏
      addPeerSpan: true,
      // 上一个目录的取消和保存按钮的key值
      previousKeyFirst: null,
      previousKeySecond: null,
      previousKeyThird: null,

      // 设置添加同级目录文本框的值
      addPeerText: "",
      // 设置添加子级目录文本框的值
      addSonText: "",

      // 控制缩略图的批量删除的弹窗
      itemShow: false,
    };
  },
  created(){

    this.originaldata = this.$store.state.originaldata;
  },
  mounted() {
  },
  components: {

    ShowLock,
    sModal,
  },

  computed: {
    search() {
      return this.searchText.length;
    },
  },

  methods: {
    initFirstNode(list) {
      if (list.length > 0) {
        let nodes = document.getElementsByClassName('first-chapter-name')
        this.$nextTick(() => {
          let node = nodes[0];
          node.click()
        })
      }
    },
    getcoursedata(){
      this.$emit("getcoursedata");
    },
    getnode(){
      this.$emit("getnode");
    },
    //添加组件渲染页面
    // getinfo(argu) {
    //   this.file_attr = argu[0];
    //   this.$forceUpdate();
    // },
    // 获取到search组件文本框的值
    // getSearch(msg) {
    //   this.searchcontent = msg;
    //   this.getcoursedata();
    // },

    show_bgc(element) {
      element.target.style.background = "#f0f0f0";
    },

    // 点击目录进行折叠子级目录
    showIcon(element, parentNodeid, courseNodeId, addson, highlight) {
      console.log('点击目录点击目录', element, parentNodeid, courseNodeId)
      this.originaldata.map((item) => {
        if(item.courseNodeId == courseNodeId){
          item.show = !item.show
        }
      });
      if (highlight) {
        this.highlight(element, parentNodeid, courseNodeId, addson);
      }
      this.courseNodeId = courseNodeId,
        this.$store.commit('getcourseNodeId',this.courseNodeId)
        // this.$parent.courseNodeId = this.courseNodeId
      
      // this.getcoursedata();
    },
    //设置高亮
    highlight(element, parentNodeid, courseNodeId, addson) {
      // 清空所有的一级目录背景颜色
      var title_parent = document.getElementsByClassName("detail-title");
      for (var i = 0; i < title_parent.length; i++) {
        title_parent[i].style.background = "#fff";
      }
      //清空所有的二级目录背景颜色
      var title_son = document.getElementsByClassName("detail-title-children");
      for (var j = 0; j < title_son.length; j++) {
        title_son[j].style.background = "#fff";
      }
      // 清空所有的三级目录背景颜色
      var title_grand_son = document.getElementsByClassName("detail-title-son");
      for (var n = 0; n < title_grand_son.length; n++) {
        title_grand_son[n].style.background = "#fff";
      }

      // 给所有元素清空 左边框的样式
      var list_p = document.getElementsByClassName("list-p");
      for (var v = 0; v < list_p.length; v++) {
        list_p[v].style.borderLeft = "";
      }

      // 给当前元素添加一个左边框
      element.target.parentNode.style.borderLeft = "4px solid #2eadb5";

      // 清空所有三级目录下的左边框
      var need_edit_name = document.getElementsByClassName("need-edit-name");
      for (var o = 0; o < need_edit_name.length; o++) {
        need_edit_name[o].style.borderLeft = "";
      }
      var current_ele = element.target.parentNode;
      current_ele.style.background = "#f0f0f0";
      this.parentNodeid = parentNodeid;
      this.courseNodeId = courseNodeId;
      this.$store.commit('getcourseNodeId',this.courseNodeId)
      this.$store.commit('getparentNodeid',this.parentNodeid)
      this.addson = addson;
      this.getcoursedata();
    },

   

    // 点击，选中目录
    showTitle(element, parentNodeid, courseNodeId, addson) {
      // 清空所有的一级目录背景颜色
      var title_parent = document.getElementsByClassName("detail-title");
      for (var i = 0; i < title_parent.length; i++) {
        title_parent[i].style.background = "#fff";
      }
      //清空所有的二级目录背景颜色
      var title_son = document.getElementsByClassName("detail-title-children");
      for (var j = 0; j < title_son.length; j++) {
        title_son[j].style.background = "#fff";
      }
      // 清空所有的三级目录背景颜色
      var title_grand_son = document.getElementsByClassName("detail-title-son");
      for (var n = 0; n < title_grand_son.length; n++) {
        title_grand_son[n].style.background = "#fff";
      }

      // 给所有元素清空 左边框的样式
      var list_p = document.getElementsByClassName("list-p");
      for (var v = 0; v < list_p.length; v++) {
        list_p[v].style.borderLeft = "";
      }

      // 给当前元素添加一个左边框
      element.target.style.borderLeft = "4px solid #2eadb5";

      // 清空所有三级目录下的左边框
      var need_edit_name = document.getElementsByClassName("need-edit-name");
      for (var o = 0; o < need_edit_name.length; o++) {
        need_edit_name[o].style.borderLeft = "";
      }
      this.parentNodeid = parentNodeid;
      this.courseNodeId = courseNodeId;
      this.addson = addson;
      var current_ele = element.target;
      current_ele.style.background = "#f0f0f0";
      this.$store.commit('getcourseNodeId',this.courseNodeId)
      this.$store.commit('getparentNodeid',this.parentNodeid)
      // this.$parent.courseNodeId = this.courseNodeId
      this.getcoursedata()
    },
    del_detail_title() {
      this.edit_del_turn = !this.edit_del_turn;
      var edit_del = document.getElementsByClassName("title_list")[0];
      //根据edit_del_turn的值来设置元素显示或隐藏
      if (this.edit_del_turn) {
        edit_del.style.display = "block";
      } else {
        edit_del.style.display = "none";
      }
    },
    // 添加同级目录
    addPeer() {
      // 重置添加同级目录的文本框
      this.addPeerText = "";
      // var add_dir_index = this.add_dir_index;
      // 设置文本框为显示
      // this.addPeerShow = true;
      this.addPeerShow = !this.addPeerShow;
      this.addSonShow = false;

      // 聚焦文本框
      this.$nextTick(function () {
        this.$refs.peerInput.focus();
      });
      this.addPeerSpan = true;
      this.old_text = this.addPeerText;
    },
    // 添加同级目录的保存按钮
    addSave() {
      // 隐藏输入框
      if(this.addPeerText!==""){
        this.courseNodeId = this.$store.state.courseNodeId
      this.parentNodeid = this.$store.state.parentNodeid
      this.addPeerShow = false;
      addCourseNode({
        course:{
          iCourseId:localStorage.getItem("courseId")
        },
        strNodeName:this.addPeerText,
        parentNode:{
          iCourseNodeId:this.parentNodeid
        },
        ddNodeType:{
          iNumber:0
        },
        ddNodeState:{
          iNumber:1
        }
      }).then((response)=>{
        if(response.data.iCode == 0){
          sessionStorage.setItem("iCourseNodeIdss",response.data.objData.parentNode.iCourseNodeId)
          this.getnode()
        }else{
          return this.$message.error(response.data.strMessage);
        }
      })

      }else{
        return this.$message.error(this.$t('translateText.catalog.bnwk'));
      }
      
    },
    // 添加同级目录的取消按钮
    addCancel() {
      this.addPeerShow = false;
    },
    // 添加子级 目录
    addSon() {
      // 初始化文本框的值
      this.addSonText = "";
      // 设置文本框为显示
      this.addSonShow = !this.addSonShow;
      this.addPeerShow = false;

      // 聚焦文本框
      this.$nextTick(function () {
       this.$refs.sonInput.focus();
      });
    },
    // 添加子级目录的 保存按钮
    addSonSave() {
      if(this.addSonText!==""){
         this.courseNodeId = this.$store.state.courseNodeId
      this.parentNodeid = this.$store.state.parentNodeid
      if(this.courseNodeId == -1){
        return this.$message.error(this.$t('translateText.ct.xzfml'))
      }
      var isreturn = false;
      this.$store.state.coursefile.map((item) => {
        if (item.courseNode.iCourseNodeId == this.courseNodeId) {
          isreturn = true;
        }
      });
      if (isreturn) {
        return this.$message.error(this.$t('translateText.ct.wftjml'))
        // return this.$message.error("该目录已添加课程资料，无法添加子级目录！");
      }
      // 隐藏输入框
      this.addSonShow = false;
      addCourseNode({
        course: {
          iCourseId: localStorage.getItem("courseId"),
        },
        strNodeName: this.addSonText,
        parentNode: {
          iCourseNodeId: this.courseNodeId,
        },
        ddNodeType: {
          iNumber: 0,
        },
        ddNodeState: {
          iNumber: 1,
        },
      }).then((response) => {
        if (response.data.iCode == 0) {
             this.getnode();
              sessionStorage.setItem("iCourseNodeIdss",response.data.objData.parentNode.iCourseNodeId)       
        } else {
          return this.$message.error(response.data.strMessage);
        }
      });

      }else{
        return this.$message.error(this.$t('translateText.catalog.bnwk'));
      }
    },
    // 添加子级目录的 取消按钮
    addSonCancel() {
      // 隐藏输入框
      this.addSonShow = false;
    },

    // 单击修改图标，修改章节的名称
    editIconTitle(courseNodeId) {
      this.originaldata.map((item,i) => {
          item.showText = true;
          item.miniIcon = true;
      
        if (item.courseNodeId == courseNodeId) {
          item.showText = !item.showText;
          item.miniIcon = !item.miniIcon;
               this.$nextTick(function () {
                this.$refs.inputVal[i].focus();
                });
   

          
        }
      }); 
    },
   
    // 保存按钮
    editSave(CourseNodeId) {
      this.originaldata.map((item) => {
        if (item.courseNodeId == CourseNodeId) {
          this.NodeName = item.name;
          this.nodeState = item.nodeState;
        }
      });
      updateCourseNode({
        CourseNodeId: [{iCourseNodeId:CourseNodeId}],
        strNodeName: this.NodeName,
        ddNodeState: {
          iNumber: this.nodeState,
        },
      }).then((response) => {
        if(response.data.iCode == 0){
          this.originaldata.map((item) => {
            if (item.courseNodeId == CourseNodeId) {
              item.showText = !item.showText;
              item.miniIcon = !item.miniIcon;
            }
          }); 
        }
      });
    },

    //修改目录名输入框失去焦点
    // lostfocus(courseNodeId) {
    //   this.editSave(courseNodeId);
    // },
    // 取消按钮
    editCancel(courseNodeId) {
      this.originaldata.map((item) => {
        if (item.courseNodeId == courseNodeId) {
          item.showText = true;
          item.miniIcon = true;
        }
      });
      // this.getnode()
    },
    //更新目录状态
    updatestatue(lock, CourseNodeId,parentNodeid) {
      let lockstate = !lock
      this.nodelist = [];
      if(lock && parentNodeid !=0){//找到想要开启的目录，判断是否是一级目录，若不是将该目录的父级目录也要设置成开启状态
        this.addparent(parentNodeid)
      }
      this.originaldata.map((item) => {
        if (CourseNodeId == item.courseNodeId) {
          this.nodelist.push(item);
          this.traverse(item.children)
          this.NodeName = item.name;

        }
      });
      this.nodelist = this.nodelist.map(item =>{
        return Object.assign({},{iCourseNodeId:item.courseNodeId,strNodeName:item.name})
      })
      updateCourseNode({
        CourseNodeId: this.nodelist,
        strNodeName: this.NodeName,
        ddNodeState: {
          iNumber: lockstate == true ? 2 : 1,
        },
      }).then((response) => {
        if(response.data.iCode == 0){

          this.$emit("updatestate",response.data.objData)
          // this.$refs.catalog.loadmore()
          
        }
      });
    },
    addparent(parentNodeid){
        this.originaldata.map((item) => {
          if (parentNodeid == item.courseNodeId) {
            this.nodelist.push(item);
            if(item.parentNodeid != 0){
              this.addparent(item.parentNodeid)
            }
          }
        });
    },
    // loadmore(){
    //   this.$refs.ShowLock.loadmore()
    // },
    updatestate(info){
       this.$emit("updatestate",info)
    },
    chapterDelConfirm() {
      this.svisible = !this.svisible;

    },
    selectAll() {
      this.checkAllTurn = !this.checkAllTurn;
      for (var i = 0; i < this.file_attr.length; i++) {
        if (this.checkAllTurn) {
          this.file_attr[i].checkTurn = true;
        } else {
          this.file_attr[i].checkTurn = false;
        }
      }
    },
    //删除目录
    myDelChapter(courseNodeId) {
      this.nodelist = [];
      this.svisible = true;
      this.originaldata.map((item) => {
        if (courseNodeId == item.courseNodeId) {
          this.nodelist.push(item);
          this.traverse(item.children)
        }
      });
    },
    //遍历出目录的子目录
    traverse(arr){
      arr.map(item =>{
          this.nodelist.push(item);
        if(item.children.length>0){
          this.traverse(item.children)
        }
      })
    },
    //删除课程目录确定按钮
    confirmFn() {
      this.nodelist = this.nodelist.map(item =>{
        return Object.assign({},{icourseNodeId:item.courseNodeId})
      })
      this.nodelist.map(item=>{
        if(item.icourseNodeId == this.courseNodeId){
          this.$parent.file_attr = []
        }
      })
      this.svisible = false;
      this.itemShow = false;
      deleteCourseNode(this.nodelist).then((response) => {
        if (response.data.iCode == 0) {
          this.$store.commit("getcourseNodeId", -1);
          this.$store.commit('getparentNodeid',0)
          
          this.getnode();
        } else {
          return this.$message.error(response.data.strMessage);
        }
      });
    },
    //删除目录取消按钮
    cancelFn() {
      this.svisible = false;
      this.itemShow = false;
    },
    receiveEditShow(data) {
      this.edit_chapter_turn = data;

      this.edit_del_turn = !this.edit_del_turn;
      var edit_del = document.getElementsByClassName("title_list")[0];
      //根据edit_del_turn的值来设置元素显示或隐藏
      if (this.edit_del_turn) {
        edit_del.style.display = "block";
      } else {
        edit_del.style.display = "none";
      }
    },
    getChapterMsg(data) {
      this.chapterName = data;

      this.edit_del_turn = !this.edit_del_turn;
      var edit_del = document.getElementsByClassName("title_list")[0];
      //根据edit_del_turn的值来设置元素显示或隐藏
      if (this.edit_del_turn) {
        edit_del.style.display = "block";
      } else {
        edit_del.style.display = "none";
      }
    },
    //获取addinfo传递过来的文件属性
    getFile(msg) {
      for (var i = 0; i < msg.length; i++) {
        this.file_attr.push(msg[i]);
      }
    },
    delItem(key) {
      this.item_show = !this.item_show;

      //删除当前的item
      this.file_attr.splice(key, 1);
    },
    setAllTick() {
      // 全选按钮的勾选和取消(true为选中,false为取消)
      this.checkAllTurn = !this.checkAllTurn;
      for (var i = 0; i < this.file_attr.length; i++) {
        if (this.checkAllTurn) {
          this.file_attr[i].checkTurn = true;
        } else {
          this.file_attr[i].checkTurn = false;
        }
      }
    },
    setTick(key) {

      // this.file_attr[key].checkTurn = !this.file_attr[key].checkTurn;
      this.file_attr[key]["checkTurn"] = !this.file_attr[key]["checkTurn"];
      // 强制刷新页面
      this.$forceUpdate();
    },


    //批量删除资料确定按钮
    itemDelete() {
      this.deleteFile();
      this.itemShow = !this.itemShow;
    },
    showModel() {
      var showMessage = false;
      if (this.file_attr.length == 0) {
        // return this.$message.error("没有选择需要删除的课程");
        this.$message.error(this.$t('translateText.gl.xzsc'));
        showMessage = true;
      } else {
        // this.itemShow = !this.itemShow;
        for (var i = 0; i < this.file_attr.length; i++) {
          if (!this.file_attr[i].checkTurn) {
            this.itemShow = !this.itemShow;
            showMessage = true;
            break;
          } else {
            showMessage = false;
          }
        }
      }

      if (showMessage == false) {
        this.$message.error(this.$t('translateText.gl.xzsc'));
      }
    },

    showSlide() {
      let slideId = 6;
      let iUserId = 2;
      let courseFileId = 2;
      //1:添加截图，2：添加标注，1.1：查看他人截图，1.2：更新/删除自己截图,1.3:更新/删除他人截图，2.1：查看他人标注，2.2：更新/删除自己标注，2.3：更新/删除他人标注，
      //3:图像调整，4：分屏，5：病人详情，6：切片详情，7：诊断病例，8：笔记，9：讨论
      let permissions = [1, 2, 6, 9, 1.2, 2.2];
      permissions = CryptoJS.enc.Utf8.parse(JSON.stringify(permissions));
      let cryptPwd = CryptoJS.AES.encrypt(
        permissions,
        CryptoJS.enc.Utf8.parse("12345678123456781234567812345678"),
        {
          mode: CryptoJS.mode.ECB,
        }
      ).toString();
      cryptPwd = encodeURIComponent(cryptPwd);
      this.$router.push(
        "/courseContent/Resources/ShowSlide?slideId=" +
          slideId +
          "&courseFileId=" +
          courseFileId +
          "&userId=" +
          iUserId +
          "&p=" +
          cryptPwd
      );
    },
    checkAll() {
      if (this.checked) {
        this.checkModel = [];
      } else {
        this.checkModel = this.courseinfoarr;
      }
    },
    update() {
      this.getcoursedata();
    },
  },
  watch: {
    '$store.state.originaldata':function(){
      this.originaldata = this.$store.state.originaldata;
    },
    checkModel() {
      this.indexarr = [];
      this.pitcharr = [];
      this.checkModel.map((item, index) => {
        if (item) this.indexarr.push(index);
      });
      this.indexarr.map((item) => {
        this.pitcharr.push(this.file_attr[item]);
      });
      if (this.pitcharr.length == this.file_attr.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },

    initialarr:function(initialarr){
      this.$store.commit('getoriginaldata',initialarr)
      this.originaldata = this.$store.state.originaldata;
    },
  },
};
</script>
<style lang="stylus" scoped>
/deep/.anticon svg{
    margin-bottom: 4px;
}
.display{
  visibility:""
}
.hidden{
  visibility:hidden
}
.study-main {
  width: 100%;
  height: 100%;
  position: relative;
}

.study-left {
  width: 27%;
  height: 100%;
  background-color: #fff;
  float: left;
  text-align: left;
  border-right: 1px solid #ccc;
  box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.11);
  overflow-y: auto;
}

.study-right {
  width: 70%;
  height: 100%;
  background-color: #fff;
  float: left;
}

.dir {
  margin-top: 5%;
  margin-left: 5%;
  font-size: 16px;
  font-weight: bold;
}

.dir-double {
  margin-top: 6%;
  margin-left: 5%;
  font-size: 16px;
  margin-bottom: 8%;
}

.dir-double span {
  margin-right: 8%;
  /* margin-left:3%; */
}

.dir-double .blue {
  margin-right: 3%;
}

.dir-double .orange {
  margin-right: 3%;
}

.dir-detail {
}

.add-chapter-input {
  margin-top: 3%;
  margin-left: 5%;
  border-left: 4px solid #2EADB5;
  background-color: #f0f0f0;
  padding-left: 1%;
  padding-top: 1%;
  padding-bottom: 1%;
  background-color: #ccc;
}
.add-chapter-input-peer {
  border-left: 4px solid #63b9f7;
}
.add-chapter-input-son {
  border-left: 4px solid #f75d28;
}

.dir-detail .detail-title {
  padding-left: 5%;
  font-size: 16px;
  // border-left: 4px solid #2EADB5;
}

.dir-detail p {
  padding-top: 5%;
  padding-bottom: 4%;
  font-size: 14px;
}

.dir-detail p:hover {
  background: #F0F0F0;
  cursor: pointer;
  border-left: 4px solid #2EADB5;
}

.dir-detail p:hover .edit-lock {
  display: block;
}

.dir-detail p:hover .edit-del {
  display: block;
}

.dir-detail p:hover .edit-icon {
  display: block;
}

.detail-title-children {
  padding-left: 10%;
}

.detail-title-son {
  padding-left: 15%;
}

.detail-title-son .need-edit-name {
  border-left: 0px;
}

.dir-detail /deep/.anticon-caret-down {
  margin-right: 4%;
}

.dir-detail /deep/.anticon-caret-right {
  margin-right: 4%;
}

.dir-detail /deep/.anticon-caret-up {
  margin-right: 4%;
}

.blue {
  color: #2FA2F4;
}

.orange {
  color: #F75D28;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: ' ';
  clear: both;
  height: 0;
}

.searchbox {
  width: 25%;
  position: relative;
  float: right;
  right: 19px;
}

.study-right {
  width: 73%;
  text-align: left;
  padding-left: 1%;
}

.study-right div {
  margin-top: 1%;
}

.study-right div:first-child {
  // margin-top: 2%;
}

.content-top span {
  font-size: 16px;
  font-weight: bold;
}

.content-top input {
  margin-top: 2%;
}

.content-btns .btns-btn {
  display: inline-block;
  // margin-right: 3%;
}

.content-btns span {
  margin-left: 1%;
  margin-right: 2%;
}

.content-main {
  margin-top: 0;
  width: 100%;
  height: 82%;
  background-color: #fff;
  overflow-y: scroll;
}

.content-item {
  width: 24%;
  height: 33%;
  margin-right: 1%;
  display: inline-block;
  background-color: #F6F6F6;
  margin-bottom: 2%;
}

.content-item .item-img {
  // width: 100%;
  // height: 60%;
}

.content-item p {
  padding: 1% 0;
  margin-left: 5%;
}

.content-item p.item-author {
  padding-bottom: 2%;
}

.item-name {
  font-size: 16px;
  width: 20px;
}

.edit-alter {
  float: right;
  margin-right: 6%;
}

.edit-alter:hover {
  cursor: pointer;
}

.edit-del {
  float: right;
  margin-right: 4%;
  display: none;
}

.edit-del:hover {
  cursor: pointer;
}

.edit-icon {
  float: right;
  display: none;
}

.edit-icon:hover {
  cursor: pointer;
}

.content-main .content-item {
  margin-top: 0;
  padding-top: 0;
}

.person-name {
  padding-right: 3%;
  border-right: 1px solid #000;
}

.book-name {
  padding-left: 3%;
}

.btn-check {
  float: right;
  margin-right: 3.5%;
  color: #2EADB5;
}

.btn-selectd-check {
  background-color: #2EADB5;
  color: #fff;
  border-color: #fff;
}

.font-small {
  font-size: 13px;
  color: #969696;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: ' ';
  clear: both;
  height: 0;
}

#beyong_hidden {
  width: 67%;
  display: inline-block;
  overflow: hidden;
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.edit-lock {
  margin-left: 4%;
  margin-right: 4%;
  display: none;
}

.edit-save {
  display: inline-block;
  line-height: 1.5;
  font-size: 14px;
  float: right;
  // margin-left:1%;
  margin-right: 4%;
  padding-top: 1px;
  color: #454E59;
}

.edit-cancel {
  color: #454E59;
  display: inline-block;
  line-height: 1.5;
  font-size: 14px;
  float: right;
  padding-top: 1px;
  margin-right: 2%;
}

.edit-save:hover {
  color: #2EADB5;
}

.edit-cancel:hover {
  color: #2EADB5;
}

.edit-btns {
  float: right;
  // margin-left: 5%;
  // margin-right: 2%;
}

.btn-selectd-check {
  color: #2EADB5;
  background: #fff;
  border: none;
}

/deep/ .btn-selected-check {
  display: none;
}

.none-outline {
  outline: none;
  background: pink;
}

.edit-item-del {
  float: right;
  margin-right: 4%;
}

.edit-item-del:hover {
  cursor: pointer;
}

.dir-peer {
  cursor: pointer;
}

.dir-son {
  cursor: pointer;
}

.select-all {
  cursor: pointer;
}

.select-all-icon {
  color: #2EADB5;
}

.edit-chapter-name {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.first-chapter-name {
  width:55%;
}

.second-chapter-name {
  width: 55%;
}

.third-chapter-name {
  width: 50%;
}
// .third-chapter-name {
//   width: 25%;
// }

.edit_input {
  width: 50%;
  outline: none;
  border: 1px solid #ccc;
}

#add-dir-cancel {
  color: #454E59;
  cursor: pointer;
}

#add-dir-save {
  color: #454E59;
  cursor: pointer;
}

#add-dir-cancel:hover {
  color: #2EADB5;
}

#add-dir-save:hover {
  color: #2EADB5;
}

#add-son-save {
  cursor: pointer;
  color: #454E59;
}

#add-son-cancel {
  color: #454E59;
  cursor: pointer;
}

#add-son-save:hover {
  color: #2EADB5; 
}

#add-son-cancel:hover {
  color: #2EADB5;
}

/deep/.ant-checkbox-wrapper {
  margin-left: 25px;
}
</style>